/* FragranceUSA product page */
(function () {
  'use strict';

  var OZ_TO_ML = { '0.17': 5, '0.27': 8, '0.33': 10, '0.34': 10, '0.5': 15, '1': 30, '1.6': 50, '1.7': 50, '2': 60, '2.4': 70, '2.5': 75, '2.7': 80, '3': 90, '3.3': 100, '3.4': 100, '3.5': 100, '4': 120, '4.2': 125, '5': 150, '6.7': 200, '6.8': 200, '8.4': 250, '17': 500 };
  var CONCS = [
    ['extrait de parfum', 'Extrait de Parfum'], ['demi extrait', 'Demi Extrait'],
    ['eau de parfum intense', 'Eau de Parfum Intense'], ['eau de parfum', 'Eau de Parfum'],
    ['eau de toilette', 'Eau de Toilette'], ['eau de cologne', 'Eau de Cologne'],
    ['parfum cologne', 'Parfum Cologne'], ['parfum', 'Parfum'], ['cologne', 'Cologne']
  ];

  function titleCase(s) { return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }

  function parseVariant(v) {
    var s = (v.title || '').toLowerCase();
    var out = { conc: '', ml: null, oz: null, kind: 'full', note: '', isSet: false, label: v.title };
    for (var i = 0; i < CONCS.length; i++) { if (s.indexOf(CONCS[i][0]) !== -1) { out.conc = CONCS[i][1]; break; } }
    out.isSet = /gift ?set|giftset|\bset\b| x \d|\+/.test(s);
    if (/sample|atomizer|decant/.test(s)) out.kind = 'sample';
    else if (/tester/.test(s)) out.kind = 'tester';
    var note = (v.title.match(/\(([^)]*)\)/) || [])[1] || '';
    note = note.replace(/comes in atomizer pictured/i, 'in travel atomizer').replace(/^\s*sample\s*$/i, '').trim();
    out.note = note;
    if (!out.isSet) {
      var mlm = s.match(/(\d+(?:\.\d+)?)\s*ml/);
      var ozm = s.match(/(\d*\.?\d+)\s*oz/);
      if (ozm) out.oz = parseFloat(ozm[1]);
      if (mlm) out.ml = parseFloat(mlm[1]);
      else if (out.oz) out.ml = OZ_TO_ML[String(out.oz)] || Math.round(out.oz * 29.5735);
      if (out.oz && out.ml) out.label = out.oz + ' oz · ' + out.ml + ' ml';
      else if (out.ml) out.label = out.ml + ' ml';
    }
    if (out.isSet || (!out.ml && !out.oz)) {
      out.label = titleCase(v.title.replace(/\([^)]*\)/g, '').replace(out.conc.toLowerCase(), '').trim()) || v.title;
    }
    return out;
  }

  function Pdp(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-fusa-json]').textContent);
    this.money = this.data.moneyFormat;
    this.variants = this.data.variants.map(function (v) { v.p = parseVariant(v); return v; });
    this.current = this.variants.filter(function (v) { return v.id === this.data.selectedId; }, this)[0] || this.variants[0];
    this.els = {
      list: root.querySelector('[data-size-list]'), hint: root.querySelector('[data-size-hint]'),
      price: root.querySelector('[data-price]'), ppm: root.querySelector('[data-ppm]'), conc: root.querySelector('[data-conc]'),
      id: root.querySelector('[data-variant-id]'), add: root.querySelectorAll('[data-add]'), qty: root.querySelector('[data-qty]'),
      compare: root.querySelector('[data-compare]'), msg: root.querySelector('[data-msg]'),
      sticky: root.querySelector('[data-sticky]'), stickyMeta: root.querySelector('[data-sticky-meta]')
    };
    this.computeBestValue();
    this.renderSizes();
    this.select(this.current, false);
    this.bind();
    this.gallery();
    this.stickyObserver();
  }

  Pdp.prototype.fmt = function (cents) {
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return this.money.replace(/\{\{\s*\w+\s*\}\}/, withCommas.replace(/\.00$/, '') === withCommas ? withCommas : withCommas);
  };
  Pdp.prototype.ppm = function (v) { return v.p.ml && !v.p.isSet ? v.price / v.p.ml : null; };

  Pdp.prototype.computeBestValue = function () {
    var self = this, best = null, candidates = 0;
    this.variants.forEach(function (v) {
      if (v.p.kind === 'sample' || v.p.isSet) return;
      var r = self.ppm(v); if (!r) return; candidates++;
      if (!best || r < self.ppm(best)) best = v;
    });
    this.best = candidates > 1 ? best : null;
  };

  Pdp.prototype.renderSizes = function () {
    var self = this, html = '';
    this.variants.forEach(function (v) {
      var r = self.ppm(v);
      var kind = v.p.kind === 'sample' ? 'Sample' : v.p.kind === 'tester' ? 'Tester' : (v.p.conc || 'Full bottle');
      var extra = v.p.note ? ' · ' + v.p.note : '';
      html += '<button type="button" role="radio" class="fusa-size' + (v.available ? '' : ' fusa-size--soldout') + '" data-vid="' + v.id + '" aria-checked="false">' +
        (self.best && self.best.id === v.id ? '<span class="fusa-size__flag">Best value</span>' : '') +
        '<span class="fusa-size__label">' + v.p.label + '</span>' +
        '<span class="fusa-size__kind">' + kind + extra + '</span>' +
        '<span class="fusa-size__price">' + self.fmt(v.price) + '</span>' +
        (r ? '<span class="fusa-size__ppm">' + self.fmt(r) + ' / ml</span>' : '') +
        '</button>';
    });
    this.els.list.innerHTML = html;
    if (this.best && this.els.hint) this.els.hint.textContent = 'Best value: ' + this.best.p.label.split(' · ').pop() + ' at ' + this.fmt(this.ppm(this.best)) + '/ml';
  };

  Pdp.prototype.select = function (v, updateUrl) {
    var self = this;
    this.current = v;
    this.els.list.querySelectorAll('.fusa-size').forEach(function (b) { b.setAttribute('aria-checked', String(Number(b.dataset.vid) === v.id)); });
    this.els.price.textContent = this.fmt(v.price);
    var r = this.ppm(v);
    this.els.ppm.textContent = r ? this.fmt(r) + ' / ml' : '';
    if (this.els.conc) this.els.conc.textContent = v.p.conc || this.data.defaultConc || '';
    this.els.id.value = v.id;
    var short = v.p.ml && !v.p.isSet ? (v.p.oz ? v.p.oz + ' oz' : v.p.ml + ' ml') : 'to bag';
    this.els.add.forEach(function (b) {
      b.disabled = !v.available;
      b.textContent = v.available ? 'Add ' + short + ' · ' + self.fmt(v.price) : 'Sold out';
    });
    if (this.els.stickyMeta) this.els.stickyMeta.textContent = v.p.label + ' · ' + this.fmt(v.price);
    this.renderCompare(v);
    if (updateUrl !== false && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
    }
  };

  Pdp.prototype.renderCompare = function (v) {
    var el = this.els.compare; if (!el) return;
    var c = this.data.compare;
    var brand = v.brandPrice; // cents or null
    var showBrand = brand && brand >= v.price;
    var title = c.titleDefault, save = '';
    if (showBrand && brand - v.price >= 100) {
      title = c.titleSave;
      save = 'You save ' + this.fmt(brand - v.price) + ' vs. the brand’s own site';
    } else if (showBrand) {
      title = c.titleSame;
    }
    var rows = [
      ['Price', '<span>' + this.fmt(v.price) + '</span>', showBrand ? this.fmt(brand) : '—', showBrand ? c.priceDept : '—', c.priceMarket],
      ['Shipping', c.shipUs, c.shipBrand, c.shipDept, c.shipMarket],
      ['Free sample', c.sampleUs, c.sampleBrand, c.sampleDept, c.sampleMarket],
      ['Authenticity', c.authUs, c.authBrand, c.authDept, c.authMarket]
    ];
    var body = rows.map(function (r) {
      return '<tr><th scope="row">' + r[0] + '</th><td class="is-us">' + r[1] + '</td><td>' + r[2] + '</td><td>' + r[3] + '</td><td>' + r[4] + '</td></tr>';
    }).join('');
    el.innerHTML = '<div class="fusa-compare__head"><p class="fusa-compare__title">' + title + '</p>' + (save ? '<span class="fusa-compare__save">' + save + '</span>' : '') + '</div>' +
      '<div class="fusa-compare__scroll"><table><thead><tr><th scope="col"><span class="visually-hidden">Compare</span></th><th scope="col" class="is-us">FragranceUSA</th><th scope="col">Brand website</th><th scope="col">Department stores</th><th scope="col">Marketplaces</th></tr></thead><tbody>' + body + '</tbody></table></div>' +
      (showBrand && v.brandChecked ? '<p class="fusa-compare__foot">Brand price from the brand’s official US website for this size, checked ' + v.brandChecked + '.</p>' : '');
  };

  Pdp.prototype.bind = function () {
    var self = this;
    this.els.list.addEventListener('click', function (e) {
      var b = e.target.closest('.fusa-size'); if (!b) return;
      var v = self.variants.filter(function (x) { return x.id === Number(b.dataset.vid); })[0];
      if (v) self.select(v);
    });
    this.els.list.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var i = self.variants.indexOf(self.current), d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var n = self.variants[(i + d + self.variants.length) % self.variants.length];
      self.select(n); self.els.list.querySelector('[data-vid="' + n.id + '"]').focus();
    });
    this.root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = self.els.qty; q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.qtyStep));
      });
    });
    this.els.add.forEach(function (b) { b.addEventListener('click', function () { self.addToCart(); }); });
  };

  Pdp.prototype.addToCart = function () {
    var self = this, v = this.current; if (!v.available) return;
    var drawer = document.querySelector('cart-drawer');
    this.els.add.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    if (this.els.msg) this.els.msg.textContent = '';
    var body = { items: [{ id: v.id, quantity: parseInt(this.els.qty.value, 10) || 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { if (self.els.msg) self.els.msg.textContent = res.description || res.message || 'Could not add to bag.'; return; }
      if (drawer && typeof drawer.renderContents === 'function') {
        var state = res.items ? Object.assign({}, res.items[0] || {}, { sections: res.sections }) : res;
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
    }).catch(function () {
      if (self.els.msg) self.els.msg.textContent = 'Something went wrong. Please try again.';
    }).finally(function () { self.els.add.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  };

  Pdp.prototype.gallery = function () {
    var track = this.root.querySelector('[data-gallery]'); var dots = this.root.querySelector('[data-gallery-dots]');
    if (!track || !dots) return;
    var slides = track.children; if (slides.length < 2) return;
    var html = ''; for (var i = 0; i < slides.length; i++) html += '<button type="button" aria-label="Image ' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>';
    dots.innerHTML = html;
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var idx = Array.prototype.indexOf.call(dots.children, b);
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
    var t; track.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        Array.prototype.forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', String(i === idx)); });
      }, 60);
    });
  };

  Pdp.prototype.stickyObserver = function () {
    var sticky = this.els.sticky, main = this.root.querySelector('[data-main-buy]');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(main);
  };

  function loadRows() {
    document.querySelectorAll('[data-fusa-row]').forEach(function (row) {
      var url = row.dataset.url; if (!url) return;
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=fusa-card-grid';
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('.fusa-card')).filter(function (c) { return c.dataset.pid !== row.dataset.exclude; }).slice(0, 12);
        if (!cards.length) return;
        var target = row.querySelector('[data-target]');
        cards.forEach(function (c) { target.appendChild(document.importNode(c, true)); });
        row.hidden = false;
      }).catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('[data-fusa-pdp]').forEach(function (el) { if (!el.__fusa) { el.__fusa = new Pdp(el); } });
    loadRows();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();